module.exports = __webpack_public_path__ + "img/square-ellipsis-vertical.6dbd2a74.svg";